// eslint-disable-next-line no-restricted-imports
import {
  SaveAccountStatusDto_Input,
  MutationInput_ClientController_SaveAccountStatus_Input_Value as ClientAccountStatusTypeApi,
} from 'api/generated/graphql';
import { SaveAccountStatusParam } from 'api/types/params';

export const parseSaveAccountStatusParam = (
  param: SaveAccountStatusParam
): SaveAccountStatusDto_Input => {
  const value = ClientAccountStatusTypeApi[param.value];

  return {
    value,
    versionNumber: param.versionNumber,
  };
};
